import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceStatus, OfferStatus, OrderStatus } from './Status';
import { LeadStatusSelector } from '../../scenes/leads/status/LeadStatusSelector';

/**
 * Status chip of a document (offer, order or invoice) that opens a status
 * selector on click. The parent is responsible for persisting the new status.
 */
export const EditableDocumentStatus = ({
  type,
  status,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const statusOptions = {
    offer: [
      { label: t('Created'), status: 4, variant: 'open' },
      { label: t('Sent'), status: 0, variant: 'sent' },
      { label: t('Accepted'), status: 1, variant: 'accepted' },
      { label: t('Rejected'), status: 3, variant: 'rejected' },
    ],
    order: [
      { label: t('Created'), status: 0, variant: 'open' },
      { label: t('Sent'), status: 3, variant: 'sent' },
      { label: t('Finished'), status: 1, variant: 'finished' },
      { label: t('Canceled'), status: 2, variant: 'rejected' },
    ],
    invoice: [
      { label: t('Created'), status: 0, variant: 'open' },
      { label: t('Sent'), status: 2, variant: 'sent' },
      { label: t('Payed'), status: 1, variant: 'accepted' },
      { label: t('In Arrears'), status: 3, variant: 'expired' },
      { label: t('Refusal to Pay'), status: 4, variant: 'rejected' },
      { label: t('Invoice cancelled'), status: 5, variant: 'rejected' },
    ],
  };

  const componentMap = {
    offer: OfferStatus,
    order: OrderStatus,
    invoice: InvoiceStatus,
  };
  const StatusComponent = componentMap[type];
  if (!StatusComponent) return null;

  function handleClick(e) {
    if (disabled) return;
    setAnchorEl(anchorEl ? null : e.currentTarget);
  }

  function handleStatusChange(newStatus) {
    if (newStatus.status === status) return;
    onChange(newStatus.status);
  }

  return (
    <>
      <StatusComponent number={status} onClick={handleClick} />
      <LeadStatusSelector
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onStatusChange={handleStatusChange}
        customStatuses={statusOptions[type]}
      />
    </>
  );
};

export default EditableDocumentStatus;
